import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Dither from '../components/Dither';

export default function BasePrivacy() {
  
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'monochrome');
    root.classList.add('dark');
    window.scrollTo(0,0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Base App</title>
      </Helmet>

      <section className="w-full bg-background grid-sys min-h-screen relative overflow-hidden z-10 pt-24 md:pt-32 border-x border-border max-w-[1920px] mx-auto">
        
        <div className="col-span-12 p-6 border-b-brut bg-background relative z-20 flex justify-between items-center">
            <Link to="/base" className="font-mono text-[10px] uppercase tracking-widest text-muted hover:text-accent transition-colors flex items-center gap-2 w-fit">
                &larr; RETURN TO BASE
            </Link>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted">
                PRIVACY POLICY
            </span>
        </div>

        <div className="col-span-12 p-6 md:p-16 border-b-brut min-h-[40vh] flex flex-col justify-center relative z-10 overflow-hidden">
            {/* Dither Shape behind the title */}
            <div className="absolute top-1/2 right-12 -translate-y-1/2 w-[80vw] h-[80vw] md:w-[40vw] md:h-[40vw] rounded-full overflow-hidden z-0 opacity-60 border border-white/5 shadow-[0_0_50px_rgba(56,189,248,0.15)] pointer-events-auto">
                <Dither
                    waveColor={[56/255, 189/255, 248/255]} 
                    disableAnimation={false}
                    enableMouseInteraction
                    mouseRadius={0.3}
                    colorNum={4}
                    waveAmplitude={0.4}
                    waveFrequency={2.5}
                    waveSpeed={0.06}
                />
            </div>

            <motion.h1 
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="text-5xl md:text-7xl lg:text-8xl font-heading font-extrabold uppercase leading-[0.85] tracking-tighter text-foreground max-w-[90rem] mb-6 relative z-10"
            >
                PRIVACY.
            </motion.h1>
            <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="font-mono text-xs md:text-sm text-accent uppercase tracking-[0.2em] max-w-2xl relative z-10"
            >
                HOW WE PROTECT YOUR DATA.
            </motion.p>
        </div>

        <div className="col-span-12 p-6 md:p-16 bg-background">
            <div className="max-w-4xl mx-auto space-y-12">
                <section className="space-y-4">
                    <h2 className="text-2xl md:text-3xl font-heading uppercase tracking-tighter text-foreground">1. Local Storage</h2>
                    <p className="font-mono text-xs md:text-sm text-muted leading-relaxed uppercase">
                        All data within the Base App is strictly stored locally on your device. We do not use external databases to store your tasks, calendar events, or any personal information. Your agenda remains your property and never leaves your iPhone.
                    </p>
                </section>
                
                <section className="space-y-4">
                    <h2 className="text-2xl md:text-3xl font-heading uppercase tracking-tighter text-foreground">2. Analytics</h2>
                    <p className="font-mono text-xs md:text-sm text-muted leading-relaxed uppercase">
                        We may collect anonymous crash reports and usage statistics solely for the purpose of improving application stability and performance. This data cannot be traced back to individual users.
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-2xl md:text-3xl font-heading uppercase tracking-tighter text-foreground">3. User Consent</h2>
                    <p className="font-mono text-xs md:text-sm text-muted leading-relaxed uppercase">
                        By using Base, you consent to our privacy practices as described. If any significant changes are made to how we handle your data, this policy will be updated immediately.
                    </p>
                </section>
            </div>
        </div>
      </section>
    </>
  );
}
